export default "__VITE_ASSET__Cg323lkL__"